<template>
  <div></div>
</template>

<style></style>

<script lang="ts">
import { defineComponent, getCurrentInstance } from "vue";
import type Vue from "vue";
import { IndexedDB } from "@/indexeddb";
import { useAppStore } from "@/store";

import AppAuth, { PRODUCT_STAGE, PROVIDER } from "../aws-config";
import { ServerApiAccess } from "@/server-api-access";
import { isMobile, osType } from "@/mobile";

export default defineComponent({
  name: "logout",
  components: {},
  setup() {
    // $router は vue-router が生やす（Step 3 で composable 化予定）
    const vm = getCurrentInstance()?.proxy as Vue | undefined;

    // created 相当
    const created = async (): Promise<void> => {
      let redirectUrl = undefined;
      // direct トークン取り消し処理
      const revokeTokenPromise = async () => {
        const api = new ServerApiAccess();
        await api.revokeToken();
      };
      // DB削除
      const dropDBPromise = async () => {
        await IndexedDB.dropDB();
      };
      // サインアウト
      const signOutPromise = async () => {
        const url = await AppAuth.signOut();
        if (url) {
          redirectUrl = url;
        }
      };
      // 成功失敗に関わらず全て実行
      await Promise.allSettled([revokeTokenPromise(), dropDBPromise(), signOutPromise()]);
      if (redirectUrl) {
        let provider: PROVIDER = "direct";
        switch (PRODUCT_STAGE) {
          case "PRD":
            provider = "direct";
            break;
          case "STG":
            provider = "direct-staging";
            break;
          case "DEV":
            provider = "direct-dev";
            break;
          default:
            provider = "direct";
            break;
        }
        const device = useAppStore().device;
        if (isMobile(device)) {
          // スマホは別処理
          const type = osType(device);
          switch (type) {
            case "ios":
              await AppAuth.redirectOidcLoginUrl("direct-mobile", "ios");
              break;
            case "android":
              await AppAuth.redirectOidcLoginUrl("direct-mobile", "and");
              break;
            default:
              await AppAuth.redirectOidcLoginUrl(provider);
              break;
          }
        } else {
          await AppAuth.redirectOidcLoginUrl(provider);
        }
      } else {
        vm?.$router.replace("/", () => {
          // "/" → "/" での NavigationDuplicated が出る場合があるが、無視する
        });
      }
    };

    void created();

    return {};
  },
});
</script>
